import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageService } from "angular-web-storage";
import { PhoneService } from "../_services/phone.service";
import { environment } from "src/environment/environment";
import { Invitation, SessionState } from "sip.js";
import { firstValueFrom, Observable } from "rxjs";
import { MessageService } from "primeng/api";
import { User } from "../../users/_types/user";
import { Filter, FilterOperation, NotFilter, OrFilter } from "src/app/core/jsonapi/filter";
import { IParamsCollection } from "src/app/core/jsonapi/interfaces/params-collection";
import { FilterBuilder } from "src/app/core/jsonapi/filters-builder";
import { TabViewChangeEvent } from "primeng/tabview";
import { Call } from "../_types/call";
import { CallService } from "../_services/call.service";
import { NotificationsService } from "../../notifications/_services/notifications.service";
import { ExtensionsService } from "../../voip/_services/extensions.service";
import { WorkersService } from "../../workers/_services/workers.service";

@Component({
    selector: 'app-phone-sidebar',
    templateUrl: './phone-sidebar.component.html',
    styleUrls: ['./phone-sidebar.component.scss'],
    standalone: false
})
export class PhoneSidebarComponent implements OnInit {

    public activeIndex:number = 0;
    private logged:boolean = false;
    private invites$: Observable<Invitation> | undefined;
    public calls: Invitation[] = [];
    public localAudio!:ElementRef;
    private playRingTone: boolean = false;

    public user: any = {};
    public notifications: Notification[] = [];

    public isPhoneConnected: boolean = false;
    private intervalPhoneStatus: any;
    public notificationTypes:any[] = [];
    public phoneNumber: string = "";
    public missedCalls:any[] = [];
    public historyCalls:Call[] = [];
    public workers: any[] = [];
    public workerName: string = "";
    public totalWorkers: number = 0;
    constructor(
        private storage: LocalStorageService,
        private phoneService: PhoneService,
        private router: Router,
        private messageService: MessageService,
        private extensionsService: ExtensionsService,
        private callService:CallService,
        private notificationService: NotificationsService,
        private workerService: WorkersService
    ) {
        this.loadUserData();

        //escuchamos para saber cuando se abre y marcar pestaña de telefono
        this.phoneService.onShowSidebar.subscribe((visible:boolean) => {
            this.activeIndex = 0;
        });
    }

    ngOnInit(): void {
        /*this.phoneService.onCallingEvent.subscribe((data) => {
            this.phoneNumber = data.phoneNumber;
        });*/

        //comprobamos estado de telefono
        this.intervalPhoneStatus = setInterval(() => {
            this.isPhoneConnected = this.phoneService.isConnected;
        }, 2000);
    }

    ngDestroy(){
        clearInterval(this.intervalPhoneStatus);
    }

    async onTabChange(event: TabViewChangeEvent) {
        if (event.index == 0) {
            //telefono
        }else if (event.index == 1) {
            this.workerName = "";
            //historico llamadas
            this.loadWorkers();
        }else if (event.index == 2) {
            //historico llamadas
            this.loadUserCalls();
        }
    }
    async loadWorkers(){

        let filters = {
          name: new Filter(FilterOperation.contains, "name", ''),
          phone: new OrFilter([new NotFilter(FilterOperation.equals, "phone1","", null,true), new NotFilter(FilterOperation.equals, "phone2", "",null,true)])
        };
        if(this.workerName != null) filters.name.value = this.workerName;

        let params:IParamsCollection = {
            filter: FilterBuilder.fromObject(filters).build(),
            sort: ['name'],
            page: { number: 1, size: 10 }
        };
        let response = await firstValueFrom(this.workerService.all(params));
        this.workers = response.data;
        this.totalWorkers = response.meta["total"];
    }

    async loadUserData(){
        let user = this.storage.get("user");
        if(user){
            this.user = this.storage.get("user");
            //console.log(this.user);

            //conectamos el softphone
            if(this.user.enableSIPExtension && this.user.sipExtension){
                //let username = this.user.userName+"-wss";
                //let password = this.user.sipExtensionPassword;
                //this.phoneService.connect(environment.pbx.server, username, password);
            }
        }
    }

    async loadUserCalls(){
        let filters = {
            userId: new Filter(FilterOperation.equals, "userId", '', this.user.id)
        };
        let params:IParamsCollection = {
            filter: FilterBuilder.fromObject(filters).build(),
            sort: ['-start'],
            page: { number: 1, size: 10 }
        };
        let response = await firstValueFrom(this.callService.all(params));
        this.historyCalls = response.data;
    }

    //en una llamada interna el otro extremo es el que no es mi extensión
    internalPeer(call:Call): string | undefined {
        return call.srcNumber == this.user?.sipExtension ? call.dstNumber : call.srcNumber;
    }

    clickNumber(num:string){
        this.phoneNumber += num;
    }

    async loadPhonecall(phoneNumber:string|undefined){
        if(phoneNumber){
            this.phoneNumber = phoneNumber;
            this.activeIndex = 0;
        }
    }


    async recall(phoneNumber:string|undefined){
        if(phoneNumber){
            this.phoneNumber = phoneNumber;
            this.activeIndex = 0;
            this.call();
        }
    }

    async call(){
        console.log("Llamando a " + this.phoneNumber);
        await this.phoneService.call(this.phoneNumber);
    }

    async answer(call: Invitation) {
        console.log("Descolgando llamado");
        await this.phoneService.answer(call);
    }

    async hangup(call: Invitation) {
        console.log("Colgando llamado");
        await this.phoneService.hangup(call)
    }

}